import Vue from 'vue';
import posApplication from './pos-application/pos-application.vue';

Vue.component('pos-application', posApplication);
